import { Component, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
  standalone: false,
})
export class AppComponent {
  constructor(private router: Router) {}
}

@NgModule({
  imports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponentModule {}
